import { makeStyles, Theme } from '@material-ui/core/styles';

const styles = makeStyles(({ palette, variables }: Theme) => ({
    closeButton:{
        marginRight:variables?.spacingD,
    },
    snackBarCustomized: {
        '&.additionalMargin':{
            marginLeft:'187px'
        },
        '&.MuiSnackbar-anchorOriginTopCenter': {
            top:`calc(57px + ${variables?.spacingE})`
            
        },
        '&.MuiSnackbar-anchorOriginBottomCenter': {
            bottom:`calc(50px + ${variables?.spacingC})`,
            left:variables?.spacingC,
            right:variables?.spacingC
        },
        '& .MuiSnackbarContent-root': {
            maxWidth:'475px',
            width:'475px',
            minHeight:'64px',
            borderRadius:variables?.radiusRoundedB,
            '& p':{
                '& .jetFontIcon':{
                    marginRight:variables?.spacingB
                },
                display:'flex',
                alignItems:'center'
            }
        },
        '&.connected .MuiSnackbarContent-root': {
            backgroundColor:palette.jet?.supportPositive
        },
        '&.disconnected .MuiSnackbarContent-root': {
            backgroundColor:palette.jet?.supportInfo
        }
    }
}));

export default styles;
